import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  SimpleShowLayout,
  ReferenceField,
  ShowButton,
  DateField,
  ArrayField,
  ChipField,
  SingleFieldList,
  ShowController,
  ShowView,
} from 'react-admin';
import Icon from '@material-ui/icons/Book';
import { ListFilter, ListActions } from './ListActions';

export const BookingIcon = Icon;

export const BookingList = props => (
  <List {...props} title="Bookings" actions={<ListActions />} filters={<ListFilter />} bulkActions={false}>
    <Datagrid>
      <TextField source="wip_no" label="WIP No." />
      <DateField source="started_at" showTime={true} options={{ timeZone: 'UTC' }} />
      <ReferenceField
        label="Customer"
        sortBy="users.last_name"
        source="user_id"
        reference="customers"
        allowEmpty={true}
      >
        <TextField source="last_name" />
      </ReferenceField>
      <ReferenceField
        label="Car Brand"
        source="user_car.car_brand_id"
        sortBy="car_brands.name"
        reference="brands"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Car Model"
        source="user_car.car_model_id"
        sortBy="car_models.name"
        reference="models"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Service Consultant"
        source="service_consultant_id"
        sortBy="staffs.full_name"
        reference="service_consultants"
        allowEmpty={true}
      >
        <TextField source="full_name" />
      </ReferenceField>

      <DateField source="created_at" showTime={true} />
      <DateField source="updated_at" showTime={true} />
      <ShowButton />
    </Datagrid>
  </List>
);

export const BookingShow = props => (
  <ShowController {...props}>
    {controllerProps => (
      <ShowView {...props} {...controllerProps}>
        <SimpleShowLayout>
          <TextField source="wip_no" label="WIP No." />
          {controllerProps.record && controllerProps.record.centre_name && <TextField source="centre_name" />}
          <DateField source="started_at" showTime={true} options={{ timeZone: 'UTC' }} />
          <ReferenceField label="Customer" source="user_id" reference="customers" allowEmpty={true}>
            <TextField source="last_name" />
          </ReferenceField>
          <ReferenceField label="Car Brand" source="car_brand_id" reference="brands" allowEmpty={true}>
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField label="Car Model" source="car_model_id" reference="models" allowEmpty={true}>
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Service Consultant"
            source="service_consultant_id"
            reference="service_consultants"
            allowEmpty={true}
          >
            <TextField source="full_name" />
          </ReferenceField>
          <ArrayField source="services" label="Service Types">
            <SingleFieldList>
              <ChipField source="service_name" />
            </SingleFieldList>
          </ArrayField>
          <DateField label="Created date" showTime={true} source="created_at" />
          <DateField label="Updated date" showTime={true} source="updated_at" />
        </SimpleShowLayout>
      </ShowView>
    )}
  </ShowController>
);



// WEBPACK FOOTER //
// ./src/containers/Booking/index.js